export const UNITY_LIST = [
  {
    label: 'UNIDADE',
    value: 'UN',
  },
  {
    label: 'AMPOLA',
    value: 'AMPOLA',
  },
  {
    label: 'CONJUNTO',
    value: 'CJ',
  },
  {
    label: 'CAIXA',
    value: 'CX',
  },
  {
    label: 'CAIXA COM 2 UNIDADES',
    value: 'CX2',
  },
  {
    label: 'CAIXA COM 3 UNIDADES',
    value: 'CX3',
  },
  {
    label: 'CAIXA COM 5 UNIDADES',
    value: 'CX5',
  },
  {
    label: 'CAIXA COM 10 UNIDADES',
    value: 'CX10',
  },
  {
    label: 'CAIXA COM 15 UNIDADES',
    value: 'CX15',
  },
  {
    label: 'CAIXA COM 20 UNIDADES',
    value: 'CX20',
  },
  {
    label: 'CAIXA COM 25 UNIDADES',
    value: 'CX25',
  },
  {
    label: 'CAIXA COM 50 UNIDADES',
    value: 'CX50',
  },
  {
    label: 'CAIXA COM 100 UNIDADES',
    value: 'CX100',
  },
  {
    label: 'EMBALAGEM',
    value: 'EMBAL',
  },
  {
    label: 'FARDO',
    value: 'FARDO',
  },
  {
    label: 'QUILOGRAMA',
    value: 'KG',
  },
  {
    label: 'KIT',
    value: 'KIT',
  },
];
